import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  iconExtraAction: {
    cursor: "pointer"
  }
}));

export default styles;
